import React, { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  FaHome, 
  FaUsers, 
  FaBoxOpen, 
  FaFileInvoiceDollar, 
  FaWallet, 
  FaMoneyBillWave, 
  FaChartBar, 
  FaCog, 
  FaSignOutAlt, 
  FaUniversity,
  FaStore,
  FaShoppingCart,
  FaHistory
} from 'react-icons/fa';
import AuthContext from '../context/AuthContext';
import { BASE_URL } from '../services/api';

const Sidebar = ({ isOpen, toggle, isMobile }) => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // İzin kontrolü fonksiyonu
  const canView = (resource) => {
    if (!user) return false;
    if (user.role === 'admin') return true; // Admin her şeyi görür
    
    // Resource izinleri varsa kontrol et
    if (user.permissions && user.permissions[resource]) {
      return user.permissions[resource].view;
    }
    
    // İzin tanımı olmayan sayfalar için varsayılan davranış (False)
    return false; 
  };

  // Rol kontrolü (İzin sistemine dahil olmayan sayfalar için - Kasa, Banka, Raporlar)
  const hasRole = (roles) => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    return roles.includes(user.role);
  };

  // Bayi Kontrolü
  const isDealer = user?.role === 'bayi';

  const handleLinkClick = () => {
    if (isMobile && toggle) toggle();
  };

  return (
    <div className="d-flex flex-column p-3" style={{ width: '260px', minHeight: '100vh', position: 'fixed', top: 0, left: 0, zIndex: 1000, background: 'linear-gradient(180deg, #1e3c72 0%, #2a5298 100%)', boxShadow: '4px 0 20px rgba(0,0,0,0.1)', color: '#fff', transform: isOpen ? 'translateX(0)' : 'translateX(-100%)', transition: 'transform 0.3s ease-in-out' }}>
      <style>
        {`
          .nav-link:not(.active):hover {
            background-color: rgba(255, 255, 255, 0.15) !important;
          }
        `}
      </style>
      <div className="text-center mb-4 mt-2 p-3 rounded-3">
        <img 
          src={`${BASE_URL}/uploads/logo.png?v=${new Date().getTime()}`} 
          alt="Logo" 
          className="img-fluid mb-2" 
          style={{ maxHeight: '60px', objectFit: 'contain', filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3))' }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </div>
      <hr className="text-white-50" />
      
      <ul className="nav nav-pills flex-column mb-auto">
        
        {/* BAYİ MENÜSÜ */}
        {isDealer && (
          <li className="nav-item mb-2">
            <NavLink to="/dealer-dashboard" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
              <FaStore className="me-3" /> Bayi Paneli
            </NavLink>
          </li>
        )}

        {/* GENEL BAKIŞ (Sadece Admin/Personel/Muhasebe) */}
        {!isDealer && (
            <li className="nav-item mb-2">
              <NavLink to="/dashboard" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
                <FaHome className="me-3" /> Genel Bakış
              </NavLink>
            </li>
        )}

        {/* İZNE BAĞLI MENÜLER (Rol fark etmeksizin izin varsa göster) */}
        {canView('current_accounts') && (
          <li className="nav-item mb-2">
            <NavLink to="/current-accounts" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
              <FaUsers className="me-3" /> Cari Hesaplar
            </NavLink>
          </li>
        )}

        {canView('products') && (
          <li className="nav-item mb-2">
            <NavLink to="/products" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
              <FaBoxOpen className="me-3" /> Stok & Ürünler
            </NavLink>
          </li>
        )}

        {canView('offers') && (
          <li className="nav-item mb-2">
            <NavLink to="/offers" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
              <FaFileInvoiceDollar className="me-3" /> Teklifler
            </NavLink>
          </li>
        )}

        {canView('sales') && (
          <li className="nav-item mb-2">
            <NavLink to="/sales" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
              <FaShoppingCart className="me-3" /> Satışlar
            </NavLink>
          </li>
        )}

        {canView('payments') && (
          <li className="nav-item mb-2">
            <NavLink to="/payments" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
              <FaWallet className="me-3" /> Tahsilat & Ödeme
            </NavLink>
          </li>
        )}

        {/* Kasa, Banka ve Raporlar için özel kontrol (Admin veya Muhasebe) */}
        {hasRole(['muhasebe']) && (
          <>
            <li className="nav-item mb-2">
              <NavLink to="/cash" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
                <FaWallet className="me-3" /> Kasa Takibi
              </NavLink>
            </li>
            <li className="nav-item mb-2">
              <NavLink to="/banks" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
                <FaUniversity className="me-3" /> Banka Hesapları
              </NavLink>
            </li>
            <li className="nav-item mb-2">
              <NavLink to="/reports" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
                <FaChartBar className="me-3" /> Raporlar
              </NavLink>
            </li>
          </>
        )}

        {hasRole(['admin', 'muhasebe']) && (
          <li className="nav-item mb-2">
            <NavLink to="/logs" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
              <FaHistory className="me-3" /> İşlem Geçmişi
            </NavLink>
          </li>
        )}

        {/* Admin için Bayi Yönetimi */}
        {hasRole(['admin']) && (
          <>
            <li className="nav-item mb-2">
              <NavLink to="/dealer-stock" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
                <FaStore className="me-3" /> Bayi Stok Yönetimi
              </NavLink>
            </li>
            <li className="nav-item mb-2">
              <NavLink to="/dealer-transactions" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
                <FaChartBar className="me-3" /> Bayi Hareketleri
              </NavLink>
            </li>
          </>
        )}

        {!isDealer && (
            <li className="nav-item mb-2">
              <NavLink to="/settings" onClick={handleLinkClick} className={({ isActive }) => `nav-link d-flex align-items-center ${isActive ? 'bg-white text-primary shadow' : 'text-white'}`} style={{ borderRadius: '10px', transition: 'all 0.2s' }}>
                <FaCog className="me-3" /> Ayarlar
              </NavLink>
            </li>
        )}
      </ul>

      <hr className="text-white-50" />
      
      <div className="d-flex align-items-center mb-3 px-2">
        <div className="flex-grow-1 overflow-hidden">
          <div className="fw-bold text-truncate">{user?.full_name || 'Kullanıcı'}</div>
          <div className="small text-white-50 text-truncate" style={{ fontSize: '0.8rem' }}>
            {user?.role === 'admin' ? 'Yönetici' : user?.role === 'muhasebe' ? 'Muhasebe' : 'Personel'}
          </div>
        </div>
      </div>

      <button className="btn btn-danger w-100 d-flex align-items-center justify-content-center shadow-sm" onClick={handleLogout} style={{ borderRadius: '10px' }}>
        <FaSignOutAlt className="me-2" /> Çıkış Yap
      </button>
      <div className="text-center mt-3 text-white-50" style={{ fontSize: '0.7rem' }}>
        AMC Fikir Sanat Stok ve Muhasebe Takip v3,5
      </div>
    </div>
  );
};

export default Sidebar;
